export default __webpack_public_path__ + "static/media/pliega.77bafb8c.svg";